/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Menueditormovedown3Inputs */

const en_menueditormovedown3 = /** @type {(inputs: Menueditormovedown3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.name} down`)
};

const de_menueditormovedown3 = /** @type {(inputs: Menueditormovedown3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nach unten`)
};

/**
* | output |
* | --- |
* | "Move {name} down" |
*
* @param {Menueditormovedown3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditormovedown3 = /** @type {((inputs: Menueditormovedown3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditormovedown3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditormovedown3(inputs)
	return de_menueditormovedown3(inputs)
});
export { menueditormovedown3 as "menuEditorMoveDown" }